import Popup from "../User/popup";
import React, { useContext } from "react";
import { FormButton } from "./_input/_button";
import { DropDownInput } from "./_input/_dropdown";
import ConfirmContext from "../utils/confirmContext";
import { useTranslation } from "react-i18next";
import { useRef } from "react";
import { Price } from "./__simple/_price";
import { groupBy, mapValues, omit } from "lodash";
import { useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import config from '../configuration/config';
import { ContentLoading } from "./contentLoading";
import dropDownResetter from "../utils/resetDropDown";
import SimpleButton from "./_input/SimpleButton";
import { useUserCart } from '../User/hooks/useUserCart';
function PurchaseConfirm({
    displayConfirm = false,
    title = 'هنا يتم وضع العنوان الخاص برسالة التاكيد',
    subTitle = null,
    backGround = null,
    modelType = null,
    price = 10000,
    isOnline = false,
    image = null,
    type = null,
    isHyper = false,
    isNew = false,
    brand = null,
    brandID = null,
    cartDetails,
    modelYear,
    defaultColorID,
    carOrder,
    ColorsModel = []
}) {
    const { onClose } = useContext(ConfirmContext);
    const popupRef = useRef();
    const { t: trans, i18n } = useTranslation(["vehicales", "info", "common", "form", "inputs", "model", "new"]);
    const [show, setShow] = useState(displayConfirm);
    let lang = (i18n.language || 'ar');;
    const languageDir = 'language-' + lang;
    const history = useHistory();
    const [selectedColor, setSelectedColor] = useState(null);
    const [productTypes, setProductTypes] = useState([]);
    const [carModels, setCarModels] = useState([]);
    const [defaultProductModel, setDefaultProductModel] = useState(null);
    const [colors, setColors] = useState([]);
    const [contentLoading, setContentLoading] = useState(false);
    const { removecartItems, changecartItem } = useUserCart();
    const [brandType, setBrandType] = useState("");
    useEffect(() => {
        //intialDefaultColor(defaultColorID);
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };


    }, [displayConfirm]);

    useEffect(async () => {

        if (carOrder?.group) {
            await handleFetchModels(carOrder?.group, modelYear, true);
            // setContentLoading(false);
        }

    }, [displayConfirm]);


    useEffect(async () => {

        if (carModels && carModels?.length > 0) {

            var thisType = type;
            if (!type) {
                var _default = carModels.find(item => item.BuyOnline == true) ?? null;
                if (!_default)
                    _default = carModels[0];
                thisType = (_default && _default?.Type) ? _default?.Type : type;
            }

            await handleFetchModelAvaliableColors(thisType, true);
            setContentLoading(false);
        }
    }, [carModels]);

    useEffect(async () => {

        var bb = brand?.toLowerCase() == trans("common:toyota").toLowerCase() ? 'toyota' : 'lexus';
        setBrandType(bb);
    }, [brand]);

    // to close the popup from outside
    const handleClickOutside = (event) => {
        if (popupRef.current && popupRef.current.classList.contains(event.target.classList[0]) && displayConfirm == true) {
            onClose();
            setProductTypes([]);
            setCarModels([]);
            setColors([]);
            setPriceColor(null);
            setCart({ Id: '', colorID: '', colorNameEn: "", modelTypeDescEn: "", groupEn: "", brandEn: "", modelTypeDesc: "", Price: 0, Discount: 0, Tax: 0, ProductID: '', colorName: "", group: "", brand: "", year: "", modelType: "", showPric: false, BrandID: '', MiniDownPayment: 0 });
        }
    };

    // to order purchase
    const handleCarOrderPurchase = () => {
        history.push(`/order-car?vehicle=${carOrder?.vehicle}&model=${modelYear}&type=${Cart.modelType}&color=${Cart?.colorID}`);
        onClose();
    };

    const [PriceColor, setPriceColor] = useState(null);
    const [onLine, setOnline] = useState(false);


    const [Cart, setCart] = useState({ Id: '', colorID: '', colorNameEn: "", modelTypeDescEn: "", groupEn: "", brandEn: "", modelTypeDesc: "", Price: 0, Discount: 0, Tax: 0, ProductID: '', colorName: "", group: "", brand: "", year: "", modelType: "", showPric: false, BrandID: '', MiniDownPayment: 0 });
    function filterPriceoffColor(option) {
        setSelectedColor(option);
        setOuterCarImagesJson(null);
        //console.log("filterPriceoffColor>>>>>:", option);
        //console.log("filterPriceoffColor>>>>>carModels:", carModels);
        const selectdM = carModels?.find(item => item?.Type == option?.Type) ?? null;
        //console.log("filterPriceoffColor>>>>>selectdM:", selectdM);
        try {
            if (option.showPric || option?.buyOnline) {
                setPriceColor(option.NetSalePrice);
            } else {
                setPriceColor(null);

            }
            const currentValues = { ...Cart };
            currentValues.Id = option?.GUID;
            currentValues.brand = option["Brand Arabic"];
            currentValues.brandEn = option["Brand English"];
            currentValues.group = option["Group Arabic"];
            currentValues.groupEn = option["Group English"];
            currentValues.colorName = option["ColorDescriptionAr"];
            currentValues.colorNameEn = option["ColorDescriptionEn"];
            currentValues.colorID = option?.value;
            currentValues.Price = option?.NetSalePrice;
            currentValues.Tax = option?.TaxAmount;
            currentValues.Discount = option?.Discount;
            currentValues.ProductID = option?.ProductID;
            currentValues.BrandID = option?.BrandID;
            currentValues.image = selectdM?.Image;
            currentValues.modelType = option?.Type;
            currentValues.modelTypeDesc = option["Type Arabic"];
            currentValues.modelTypeDescEn = option["Type English"];
            currentValues.showPric = option?.showPric;
            currentValues.year = option?.Model;
            currentValues.MiniDownPayment = option.MiniDownPayment;
            currentValues.SN = option.SN;
            currentValues.Slug = option.ProductTarget;

            if (

                // ((option.TotalQtyAVA ? option.TotalQtyAVA : 0) > 0)  &&

                option?.buyOnline == true || option?.buyOnline == 1) {

                setOnline(true);
            }
            else {

                setOnline(false);
            }


            setCart(currentValues);

            fetchCarDesign(option?.value, option?.ProductID, option?.Model);

        } catch (err) {
            //console.log(err);
        }

    }
    // to fetch the model types
    const handleFetchModels = async (groupType, modelYear, setDefault = false) => {
        let _models = [];
        try {
            setContentLoading(true);

            var funName = "site_GetCarModelsAr";
            if (lang == "en") {
                funName = "site_GetCarModelsEn";
            }
            const response = await axios.post(
                `${config.controllURL}${lang}/api/Pages/${funName}`,
                {
                    "Group": groupType,
                    "Year": modelYear
                }
            );
            if (response.status == 200) {

                setCarModels(response.data);
                _models = response.data.map(item => {
                    return { value: item.Type, text: item?.ModelDescription?.replace(item?.Brand + " " + item?.Group, ""), buyOnline: item?.BuyOnline }
                });

                setProductTypes(_models);
                let _default = null;

                if (setDefault) {

                    if (type) {
                        _default = _models.find(item => item.value == type) ?? null;
                    } else {
                        _default = _models.find(item => item.BuyOnline == true) ?? null;

                        if (_default == null) {
                            _default = _models.find(item => item.value == type) ?? null;
                        }

                    }


                }
                setDefaultProductModel(_default);
            }
        } catch (error) {
            //console.log(error);
            setContentLoading(false);
        }
        return _models;
    };
    // to fetch colors based on the product type id
    const handleFetchModelAvaliableColors = async (productTypeID, setDefault = false) => {
        let _colors = [];
        setSelectedColor({ text: trans("form:color"), value: '' });
        //console.log("handleFetchModelAvaliableColors>>>>>:", setDefault);
        try {
            setContentLoading(true);

            const response = await axios.post(
                `${config.controllURL}${lang}/api/Pages/site_fetchColorOfTypeWithOutImages`,
                {
                    "Type": productTypeID,
                    "model": modelYear
                }
            );

            if (response.status == 200) {
                _colors = response.data.map(item => {
                    return { value: item.ColorID, text: item[`Color${trans("model:description")}`], buyOnline: item?.BuyOnline, ...item }
                });


                setColors(_colors);

                // setTimeout(() => {

                let _default = null;
                if (setDefault) {
                    // _default = _colors.find(item => item.value == defaultColorID) ?? null;
                    _default = _colors.find(item => item.buyOnline == true) ?? null;
                    //console.log("_default _colors>>>>>:", _default);
                    if (_default == null && _colors[0]) {

                        _default = _colors[0];
                    }

                    if (_default) {
                        filterPriceoffColor(_default);
                    }
                }


                // }, 1000)


            }


        } catch (error) {
            //console.log(error);
        }
        setContentLoading(false);
        return _colors;
    };



    const [cashCarImages, setCashCarImages] = useState({});
    const [outerCarImagesJson, setOuterCarImagesJson] = useState(null);
    const [isLoadingImages, setIsLoadingImages] = useState(false);
    const fetchCarDesign = async (activeColor, model, year) => {

        // console.log("activeColor>>>>>>>>>>>>>>>>>>>>>>>>>:", activeColor);
        // console.log("model>>>>>>>>>>>>>>>>>>>>>>>>>:", model);
        if (isLoadingImages == false) {

            const Namefiled = "frontImage,leftImage,backImage,sideImage,rightImage,mainColorImage"

            const prefix = 'data:image/png;base64,';
            if (model) {
                if (cashCarImages[model + "-part-" + 0]) {
                    setIsLoadingImages(false);
                    var AllCarImagesOUT = cashCarImages[model + "-part-" + 0];

                    setOuterCarImagesJson(AllCarImagesOUT);

                } else {
                    axios.post(
                        `${config.controllURL}${lang}/api/Pages/SiteFetchCarColorCodeImages`,
                        {
                            "Id": model,
                            "year": year,
                            // "ColorID": String(codeColor),
                            "ColorID": null,
                            "FieldNameList": null
                        }
                    ).then(response => {
                        setIsLoadingImages(false);
                        var maincolorimageIndex = 0;
                        // console.log("SiteFetchCarColorCodeImages responseData>>>>>>>>>>>>>>>>>>>>>>>>>:", response.data);
                        if (Array.isArray(response.data)) {
                            const responseData = response.data;
                            const groupResult = mapValues(groupBy(responseData, 'ColorCode'), fList => fList.map(items => omit(items, 'ColorCode')));

                            // console.log("responseData groupResult>>>>>>>>>>>>>>>>>>>>>>>>>:", groupResult);
                            setOuterCarImagesJson(groupResult);
                            cashCarImages[model + "-part-" + 0] = groupResult;
                            setIsLoadingImages(false);




                        }
                    }).catch(error => {
                        // console.log(error);
                        setIsLoadingImages(false);
                        // cashCarImages[model + "-part-" + 0] = {};
                    });

                }

            }
        }
    };
    return (
        <Popup show={displayConfirm}>
            <style>{`
                .v7-pc-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    display: flex !important;
                    flex-direction: column;
                    align-items: center !important;
                    justify-content: flex-start !important;
                    z-index: 99999;
                    background: rgba(0, 0, 0, 0.7);
                    backdrop-filter: blur(8px);
                    margin: 0 !important;
                    padding: 40px 15px !important;
                    overflow-y: auto;
                }
                @media (max-width: 850px) {
                    .v7-pc-overlay {
                        padding: 20px 10px !important;
                    }
                }
                .v7-pc-card {
                    background: var(--surface, #fff);
                    border-radius: 24px;
                    width: 100%;
                    max-width: 950px;
                    position: relative;
                    margin: 0 auto !important;
                    box-shadow: 0 40px 100px rgba(0,0,0,0.4);
                    display: flex;
                    flex-direction: column;
                    border: 1px solid rgba(0,0,0,0.1);
                    color: var(--t1, #111);
                    /* Allow dropdowns to be seen */
                    overflow: visible !important;
                    flex-shrink: 0; /* Prevent the card from shrinking */
                }
                body.dark .v7-pc-card {
                    background: #121315;
                    border-color: rgba(255, 255, 255, 0.1);
                    color: #fff;
                    box-shadow: 0 40px 100px rgba(0, 0, 0, 0.6);
                }
                .v7-pc-close {
                    position: absolute;
                    top: 15px;
                    ${lang === 'ar' ? 'left: 15px;' : 'right: 15px;'}
                    width: 38px;
                    height: 38px;
                    border-radius: 50%;
                    background: rgba(0,0,0,0.03);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    z-index: 20;
                    transition: all 0.2s;
                    border: none;
                    color: #666;
                }
                body.dark .v7-pc-close {
                    background: rgba(255,255,255,0.05);
                    color: #aaa;
                }
                .v7-pc-close:hover {
                    background: rgba(0,0,0,0.08);
                    transform: rotate(90deg);
                    color: #000;
                }
                body.dark .v7-pc-close:hover {
                    background: rgba(255,255,255,0.1);
                    color: #fff;
                }
                .v7-pc-body {
                    display: flex;
                    flex-direction: row;
                    min-height: 500px;
                }
                .v7-pc-left {
                    flex: 1.1;
                    padding: 40px;
                    display: flex;
                    flex-direction: column;
                }
                .v7-pc-right {
                    flex: 1;
                    background: linear-gradient(135deg, rgba(24, 169, 78, 0.04) 0%, rgba(24, 169, 78, 0.01) 100%);
                    padding: 40px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    border-inline-start: 1px solid rgba(0, 0, 0, 0.04);
                    position: relative;
                }
                body.dark .v7-pc-right {
                    background: linear-gradient(135deg, rgba(24, 169, 78, 0.08) 0%, rgba(18, 19, 21, 1) 100%);
                    border-inline-start-color: rgba(255, 255, 255, 0.05);
                }
                .v7-pc-brand-tag {
                    position: absolute;
                    top: 20px;
                    ${lang === 'ar' ? 'right: 30px;' : 'left: 30px;'}
                    padding: 8px 16px;
                    background: var(--surface, #fff);
                    border-radius: 12px;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    font-size: 14px;
                    font-weight: 700;
                    border: 1px solid rgba(0,0,0,0.03);
                    z-index: 5;
                }
                body.dark .v7-pc-brand-tag {
                    background: #18191b;
                    border-color: rgba(255,255,255,0.05);
                    color: #fff;
                }
                .v7-pc-brand-tag img {
                    height: 20px;
                    width: auto;
                }
                .v7-pc-tagline {
                    color: var(--g, #18a94e);
                    font-size: 13px;
                    font-weight: 700;
                    text-transform: uppercase;
                    letter-spacing: 2px;
                    margin-bottom: 8px;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }
                .v7-pc-tagline::before {
                    content: '';
                    width: 15px;
                    height: 2px;
                    background: var(--g, #18a94e);
                }
                .v7-pc-title {
                    font-size: 28px;
                    font-weight: 800;
                    margin-bottom: 30px;
                    line-height: 1.2;
                }
                .v7-pc-car-img-box {
                    width: 100%;
                    max-width: 450px;
                    margin-bottom: 30px;
                    display: flex;
                    justify-content: center;
                    position: relative;
                }
                .v7-pc-car-img {
                    width: 100%;
                    filter: drop-shadow(0 20px 40px rgba(0,0,0,0.12));
                    transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
                }
                .v7-pc-car-img:hover {
                    transform: scale(1.04);
                }
                .v7-pc-info-card {
                    width: 100%;
                    background: var(--surface, #fff);
                    border-radius: 16px;
                    padding: 20px;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.03);
                    border: 1px solid rgba(0,0,0,0.04);
                }
                body.dark .v7-pc-info-card {
                    background: #18191b;
                    border-color: rgba(255,255,255,0.05);
                }
                .v7-pc-row {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 12px;
                    font-size: 15px;
                }
                .v7-pc-label {
                    color: var(--t3, #777);
                    font-weight: 600;
                }
                body.dark .v7-pc-label {
                    color: #a1a1aa;
                }
                .v7-pc-value {
                    font-weight: 800;
                    color: var(--t1, #111);
                }
                body.dark .v7-pc-value {
                    color: #fff;
                }
                .v7-pc-price {
                    font-size: 24px;
                    font-weight: 900;
                    color: var(--g, #18a94e);
                    margin-top: 15px;
                    padding-top: 15px;
                    border-top: 1px dashed rgba(0,0,0,0.1);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                body.dark .v7-pc-price {
                    border-top-color: rgba(255,255,255,0.1);
                }
                .v7-pc-disclaimer {
                    font-size: 11px;
                    color: var(--t3, #999);
                    margin-top: 15px;
                    line-height: 1.5;
                    display: flex;
                    gap: 8px;
                }
                .v7-pc-disclaimer img {
                    opacity: 0.5;
                    width: 14px;
                    height: 14px;
                    margin-top: 2px;
                }
                .v7-pc-forms {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                    z-index: 30; /* Ensure dropdowns are above other content */
                }
                .v7-pc-actions {
                    margin-top: 30px;
                    display: flex;
                    gap: 12px;
                }
                @media (max-width: 850px) {
                    .v7-pc-body {
                        flex-direction: column-reverse;
                        min-height: auto;
                        border-radius: 20px;
                    }
                    .v7-pc-left {
                        padding: 20px;
                        border-radius: 0 0 20px 20px;
                    }
                    .v7-pc-right {
                        padding: 15px 20px; /* Reduced from 20px */
                        flex-direction: column !important;
                        gap: 8px;
                        border-inline-start: none !important;
                        border-bottom: 1px solid rgba(0, 0, 0, 0.04);
                        justify-content: center;
                        align-items: center;
                        border-radius: 20px 20px 0 0;
                    }
                    .v7-pc-car-img-box {
                        width: 100% !important;
                        max-width: 180px; /* Reduced from 240px */
                        margin-bottom: 5px !important;
                    }
                    .v7-pc-info-card {
                        width: 100% !important;
                        max-width: 280px; /* Reduced from 350px */
                        padding: 10px !important;
                        box-shadow: none;
                        background: rgba(0,0,0,0.015);
                        border: 1px solid rgba(0,0,0,0.02);
                        margin: 0 auto;
                    }
                    body.dark .v7-pc-info-card {
                        background: rgba(255,255,255,0.02);
                        border-color: rgba(255,255,255,0.04);
                    }
                    .v7-pc-row {
                        margin-bottom: 4px;
                    }
                    .v7-pc-label.text-16 {
                        font-size: 13px !important;
                        padding: 0 !important;
                    }
                    .v7-pc-value.text-16 {
                        font-size: 13px !important;
                        padding: 0;
                        background: none;
                    }
                    .v7-pc-price {
                        font-size: 16px !important;
                        margin-top: 6px;
                        padding-top: 6px;
                    }
                    .v7-pc-price .text-3xl {
                        font-size: 18px !important;
                    }
                    .v7-pc-disclaimer {
                        display: flex;
                        margin-top: 8px;
                        font-size: 10px;
                    }
                    .v7-pc-brand-tag {
                        top: 8px;
                        ${lang === 'ar' ? 'right: 12px;' : 'left: 12px;'}
                        padding: 3px 8px;
                        font-size: 10px;
                    }
                    .v7-pc-tagline {
                        font-size: 11px;
                        margin-bottom: 3px;
                    }
                    .v7-pc-title {
                        font-size: 15px !important;
                        margin-bottom: 15px !important;
                    }
                    .v7-pc-forms {
                        flex-direction: column !important; /* Stacked under each other */
                        gap: 12px;
                        overflow: visible;
                    }
                    .v7-pc-forms > div {
                        width: 100%;
                        overflow: visible;
                    }
                    .v7-pc-actions {
                        margin-top: 15px;
                        flex-direction: row !important;
                        gap: 8px;
                    }
                    .v7-pc-actions > div {
                        flex: 1;
                        width: auto !important;
                    }
                    .v7-btn {
                        padding: 12px !important;
                        font-size: 14px !important;
                    }
                }
                @media (max-width: 500px) {
                    .v7-pc-brand-tag span {
                        display: none;
                    }
                }
                .v7-btn {
                    width: 100%;
                    border-radius: 12px !important;
                    padding: 14px 20px !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    gap: 10px;
                    cursor: pointer;
                    font-weight: 700 !important;
                    transition: all 0.3s !important;
                }
                .v7-btn:hover {
                    opacity: 0.9;
                    transform: translateY(-2px);
                }
                .v7-btn img {
                    width: 20px;
                    height: 20px;
                }
                .v7-pc-not-available {
                    padding: 12px;
                    background: rgba(0,0,0,0.03);
                    border-radius: 10px;
                    text-align: center;
                    font-size: 14px;
                    font-weight: 700;
                    color: #999;
                }
                body.dark .v7-pc-not-available {
                    background: rgba(255,255,255,0.03);
                }
            `}</style>

            {contentLoading ? (
                <ContentLoading />
            ) : (
                <div className={`v7-pc-overlay ${languageDir}`} ref={popupRef}>
                    <div className="v7-pc-card" onClick={(e) => e.stopPropagation()}>
                        <button className="v7-pc-close" onClick={onClose}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>

                        <div className="v7-pc-body">
                            <div className="v7-pc-left">
                                <div className="v7-pc-tagline">{trans("new:select_model")}</div>
                                <h2 className="v7-pc-title">{trans("new:select_model_note")}</h2>

                                <div className="v7-pc-forms">
                                    <DropDownInput
                                        title={trans("info:vehicle_model")}
                                        defaultOption={defaultProductModel}
                                        options={[...productTypes]}
                                        onSelect={async (value) => {
                                            if (value === '' || value === null || value === '0' || value === undefined) {
                                                dropDownResetter(() => {
                                                    setColors([]);
                                                    setOnline(false);
                                                    setPriceColor(null);
                                                    setSelectedColor({ text: trans("form:color"), value: '' });
                                                });
                                            } else {
                                                dropDownResetter(() => {
                                                    setColors([]);
                                                    setOnline(false);
                                                    setPriceColor(null);
                                                    setSelectedColor({ text: trans("form:color"), value: '' });
                                                });
                                                await handleFetchModelAvaliableColors(value, true);
                                            }
                                        }}
                                        selectedValue={Cart?.modelType}
                                    />

                                    <DropDownInput
                                        title={trans("form:color")}
                                        options={[...colors]}
                                        onfilter={filterPriceoffColor}
                                        selectedValue={selectedColor?.value}
                                    />
                                </div>

                                <div className="v7-pc-actions">
                                    <div style={{ flex: 1 }}>
                                        <SimpleButton
                                            classes="bg-black text-white text-16 v7-btn"
                                            title={trans("info:purchase_order")}
                                            onClick={handleCarOrderPurchase}
                                        />
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        {onLine ? (
                                            <SimpleButton
                                                iconPath={'/assets/icons/cart.svg'}
                                                classes="bg-primary text-white text-12 v7-btn"
                                                title={trans("info:add_to_cart")}
                                                onClick={() => {
                                                    if (Cart) {
                                                        const obb = {
                                                            id: Cart?.Id,
                                                            Type: 'car',
                                                            colorId: Cart?.colorID,
                                                            name: Cart?.modelTypeDesc,
                                                            nameEn: Cart?.modelTypeDescEn,
                                                            price: Cart?.Price,
                                                            brand: Cart?.brand,
                                                            brandEn: Cart?.brandEn,
                                                            Tax: Cart?.Tax,
                                                            image: Cart?.image,
                                                            Discount: Cart?.Discount,
                                                            productID: Cart?.ProductID,
                                                            group: Cart?.group,
                                                            groupEn: Cart?.group,
                                                            BrandID: Cart?.BrandID,
                                                            modelTypes: Cart?.modelTypeDesc,
                                                            modelTypesEn: Cart?.modelTypeDescEn,
                                                            colorName: Cart?.colorName,
                                                            colorNameEn: Cart?.colorNameEn,
                                                            year: Cart?.year,
                                                            modelTypeID: Cart.modelType,
                                                            MiniDownPayment: Cart?.MiniDownPayment,
                                                            SN: Cart.SN,
                                                            Slug: Cart.Slug
                                                        };
                                                        changecartItem(Cart.ProductID, Cart.colorID, Cart.modelType, 1, null, null, obb, null, Cart?.year);
                                                    }
                                                    onClose();
                                                }}
                                            />
                                        ) : (
                                            <div className="v7-pc-not-available">
                                                {trans("info:not_avaliable")}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="v7-pc-right">
                                <div className="v7-pc-brand-tag">
                                    <img src={`/assets/icons/brands/${brandType}.webp`} onError={e => e.target.style.display = 'none'} />
                                    <span>{brand}</span>
                                </div>

                                <div className="v7-pc-car-img-box">
                                    {outerCarImagesJson && outerCarImagesJson[selectedColor?.value?.split("/")[0]] && (
                                        <img
                                            className="v7-pc-car-img"
                                            src={config.FilePathURL + outerCarImagesJson[selectedColor?.value?.split("/")[0]][0]?.Image_URL}
                                            alt="car preview"
                                        />
                                    )}
                                </div>

                                <div className="v7-pc-info-card">
                                    {Cart?.modelTypeDesc && (
                                        <div className="v7-pc-row">
                                            <span className="v7-pc-label text-16 px-2">{trans("info:veh_type")}:</span>
                                            <span className="v7-pc-value text-16">
                                                {lang == "ar" ? Cart?.modelTypeDesc : Cart?.modelTypeDescEn}
                                                {(Cart?.colorName || Cart?.colorNameEn) ? ` (${lang == "ar" ? Cart?.colorName : Cart?.colorNameEn})` : ""}
                                            </span>
                                        </div>
                                    )}

                                    {PriceColor && (
                                        <div className="v7-pc-price">
                                            <span className="v7-pc-label text-16">{trans("info:price")}:</span>
                                            <Price price={PriceColor} className={"font-bold text-primary text-3xl text-[#23cc4f]"} />
                                        </div>
                                    )}

                                    <div className="v7-pc-disclaimer">
                                        <img src='/assets/icons/info.svg' alt="info" />
                                        <p className="text-16">
                                            {lang == "ar"
                                                ? "السعر يشمل اللوحات والاستمارة ورسوم استهلاك الوقود وضريبة القيمة المضافة."
                                                : "The price includes license plates, registration, fuel consumption fees, and VAT."}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Popup>
    );
};

export default PurchaseConfirm;